<template>
  <div>
    <div>
      <!-------- start toast / snackbar------------------->
      <success-toast-component :SuccessToast="SuccessToast" @close="close" />
      <error-toast-component :ErrorToast="ErrorToast" @close="close" />
      <!-------- end toast / snackbar------------------->
      <!------------------section one------------------------>
      <v-row class="d-flex justify-space-between" flat>
        <v-col md="8" sm="">
          <h1 class="heading-1">PaRama Campus Royalty</h1>
        </v-col>
        <!--------------------------- add courses --------------------------------------->
        <v-col md="4" sm="">
          <v-card flat class="d-flex justify-end mt-2">
            <!-- <v-btn color="primary">Add new</v-btn> -->

            <!-- <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="text_style px-14"
                >
                  Add new
                </v-btn>
              </template>
              <v-list>
                <v-card flat>
               
                  <router-link to="/newparamacourse" style="color: black">
                    <div class="mx-5"><b> PaRama course </b></div>
                  </router-link>
                  <v-divider class="divider"></v-divider>
                  <router-link to="/newparamabundle" style="color: black">
                    <div class="mx-5 mb-3"><b>PaRama Bundle </b></div>
                  </router-link>
                </v-card>
              </v-list>
            </v-menu> -->
          </v-card>
        </v-col>
      </v-row>
      <!------------------section two------------------------>
      <div class="my-3">
        <v-row class="mt-6">
          <v-col cols="12" md="4" sm="6">
            <v-card flat>
              <v-text-field
                dense
                outlined
                prepend-inner-icon="mdi-magnify"
                label="Search"
                single-line
              >
              </v-text-field>
            </v-card>
          </v-col>
          <v-col cols="12" md="2" sm="6">
            <v-card
              height="45"
              outlined
              class="px-2 mt-n1 d-flex justify-start align-center"
              style="cursor: pointer"
              @click="filterDialog = true"
            >
              <div
                class="d-flex justify-space-between align-center"
                style="width: 100%"
              >
                <div>
                  <v-icon>mdi-tune</v-icon>
                  <span class="text_style mx-1" style="letter-spacing: 1px"
                    >Filters</span
                  >
                </div>

                <div>
                  <v-icon>mdi-menu-down</v-icon>
                </div>
              </div>
            </v-card>
            <!------------------------fliter diloag------------------------------------------>
            <v-dialog v-model="filterDialog" max-width="430" persistent>
              <v-card class="py-5">
                <v-card-title
                  class="mb-5 d-flex justify-space-between align-center"
                >
                  <div class="text-h5"><b> Filters</b></div>
                  <div>
                    <v-btn text depressed class="pa-0" @click="cleanFilter()">
                      <span
                        class="text_style primary--text"
                        style="letter-spacing: 0px"
                        >Clean filters</span
                      >
                    </v-btn>
                    <v-icon class="ml-3" @click="filterDialog = false"
                      >mdi-close</v-icon
                    >
                  </div>
                </v-card-title>

                <v-card-text>
                  <v-select
                    outlined
                    v-model="filterinstructor"
                    :items="filterinstructorArray"
                    dense
                    hide-details
                    label="Instructor"
                    multiple
                    persistent-hint
                    :menu-props="{ maxHeight: '400' }"
                  ></v-select>
                  <v-select
                  class="my-7"
                    outlined
                    v-model="filtercourse"
                    :items="filtercourseArray"
                    dense
                    hide-details
                    label="Course"
                    multiple
                    persistent-hint
                    :menu-props="{ maxHeight: '400' }"
                  ></v-select>

                  <v-select
                    outlined class=" my-7"
                    v-model="filterMonth"
                    :items="filtermonthArray"
                    dense
                    :menu-props="{ maxHeight: '400' }"
                    hide-details
                    label="Month"
                    multiple
                    persistent-hint
                  ></v-select>
                  <!---------------------Type-modalitiy model filter-------------------------------->
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#646464"
                    outlined
                    depressed
                    class="px-5"
                    text
                    @click="filterDialog = false"
                  >
                    <span class="text_style"> Cancel </span>
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="px-8 ml-2"
                    @click="filterDialog = false"
                    depressed
                  >
                    <span class="text_style"> Save Filters </span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </div>
      <!-------------------data table ------------->
      <v-card class="mt-6" outlined>
        <v-data-table
          :headers="headers"
          :loading="tableLoader"
          loading-text="Loading... Please wait"
          :search="search"
          :items="DataTableOne"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          @page-count="pageCount = $event"
          hide-default-footer
        >
          <template v-slot:[`item.index`]="{ item }">
            <b class="index_index_text"> {{ item.index }} </b>
          </template>
          <template v-slot:[`item.instructor`]="{ item }">
            <span class="index_head_text"> {{ item.instructor }} </span>
          </template>
          <template v-slot:[`item.course`]="{ item }">
            <span class="index_head_text"> {{ item.course }} </span>
          </template>
          <template v-slot:[`item.month`]="{ item }">
            <span class="index_head_text"> {{ item.month }} </span>
          </template>
          <template v-slot:[`item.royaltyrate`]="{ item }">
            <span class="index_head_text"> {{ item.royaltyrate }} </span>
          </template>
          <template v-slot:[`item.noOfStudent`]="{ item }">
            <span class="index_head_text"> {{ item.noOfStudent }} </span>
          </template>
          <template v-slot:[`item.totalRoyaltyearned`]="{ item }">
            <span class="index_head_text"> {{ item.totalRoyaltyearned }} </span>
          </template>
          <template v-slot:[`item.statement`]>
            <span class="index_head_text">
              <v-icon> mdi-file-pdf-box </v-icon>
            </span>
          </template>

          <!-- <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon @click="toggleIsPlaying(item.index)" class="mx-5">
              <v-icon v-if="item.isPlaying" color="primary">mdi-eye</v-icon>
              <v-icon v-else>mdi-eye-off</v-icon>
            </v-btn>
            <v-menu
              transition="scroll-y-transition"
              offset-y
              color="transparent"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="#A1A1A6" v-bind="attrs" v-on="on">
                  mdi-dots-horizontal
                </v-icon>
              </template>
              <v-card flat>
                <router-link to="/seeparamacourses">
                  <v-list class="px-3 pt-1" color="transparent">
                    <v-btn
                      depressed
                      color="transparent"
                      block
                      class="d-flex justify-start"
                    >
                      <v-icon color="#646464">mdi-open-in-new</v-icon>
                      <span class="ml-4 text_style action_dialog"
                        >Open PaRama Course</span
                      >
                    </v-btn>
                  </v-list>
                </router-link>

                <router-link to="/editparamacourse">
                  <v-list class="px-3 pt-1" color="transparent">
                    <v-btn
                      depressed
                      color="transparent"
                      block
                      class="d-flex justify-start"
                    >
                      <v-icon color="#646464">mdi-pencil</v-icon>
                      <span class="ml-4 text_style action_dialog"
                        >Edit parama Course</span
                      >
                    </v-btn>
                  </v-list>
                </router-link>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    to="/Seminars"
                  >
                    <v-icon color="#646464">mdi-plus-circle</v-icon>
                    <span class="ml-4 text_style action_dialog"
                      >Add new Seminar</span
                    >
                  </v-btn>
                </v-list>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                  >
                    <v-icon color="#646464">mdi-file-multiple</v-icon>
                    <span class="ml-4 text_style action_dialog"
                      >Duplicate Course</span
                    >
                  </v-btn>
                </v-list>
                <v-list
                  class="px-3 pt-1"
                  color="transparent"
                  v-if="Permission.Delete"
                >
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="dialog = true"
                  >
                    <v-icon color="#646464">mdi-delete</v-icon>
                    <span class="ml-4 text_style action_dialog"
                      >Delete Course
                    </span>
                  </v-btn>
                </v-list>
              </v-card>
            </v-menu>
          </template> -->
        </v-data-table>
      </v-card>
      <v-card flat class="my-9 d-flex justify-end align-center">
        <span class="text_transform pa-0 ma-0">Per page : </span>
        <v-card flat width="100" class="mx-5">
          <v-select
            :items="ItemsPerPageItems"
            label="Items per page"
            v-model="itemsPerPage"
          ></v-select>
        </v-card>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination
      ></v-card>
    </div>

    <!-------------Delete Dialog---------------------------->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn color="red darken-1" text @click="DeleteData()">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-----------------Organize dialog--------------------------------------->
    <v-dialog v-model="organizeDialog" persistent max-width="660">
      <v-card>
        <div class="mx-5 py-5 d-flex justify-space-between">
          <div class="d-flex align-center">
            <span class="h5 mb-1">Organize</span>
            <v-dialog v-model="newcategorydialog" persistent max-width="450">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  text
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="text_style"
                  @click="SuccessToast = false"
                >
                  + Create Category
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="py-5 d-flex justify-space-between">
                  <h5 class="text_style">Add Category</h5>
                  <v-icon @click="newcategorydialog = false">mdi-close</v-icon>
                </v-card-title>
                <v-card color="#F6F8FC" flat class="py-2 px-3">
                  <v-text-field label="Name Category" required></v-text-field>
                </v-card>
                <v-card-actions class="pb-8 pt-8">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="px-14 py-5"
                    text
                    @click="newcategorydialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn color="primary" @click="save()" class="px-14">
                    <v-progress-circular
                      indeterminate
                      size="20"
                      class="px-5"
                      color="white"
                      v-if="btnloader"
                    ></v-progress-circular>
                    <span v-else class="text_style">Save</span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <v-icon @click="organizeDialog = false">mdi-close</v-icon>
        </div>
        <OrganizeComponent
          :organizeDialog="organizeDialog"
          @close="close"
        ></OrganizeComponent>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SuccessToastComponent from "../../components/Toast/SuccessToast.component.vue";
import ErrorToastComponent from "../../components/Toast/ErrorToast.component.vue";
import OrganizeComponent from "../../components/Courses/organize.component.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    SuccessToastComponent,
    ErrorToastComponent,
    OrganizeComponent,
  },
  data() {
    return {
      AddCourseDialog: false,
      btnloader: false,
      newcategorydialog: false,
      organizeDialog: false,
      filterCourse: [],
      filterCourseArray: ["All courses", "My courses"],
      filterType: [],
      filterTypeArray: ["Course", "Parama Course", "Parama Course Bundle"],
      filterStatus: [],
      filterStatusArray: ["Draft", "Inactive", "Published"],
      filterCategory: [],
      filterCategoryArray: [
        "Anatomy and Physiology",
        "AnimalTalk",
        "BodyTalk Access",
        "BodyTalk Courses",
        "BreakThrough",
        "CEUs",
        "Conferences",
        "Courses LS",
        "FREE Courses",
        "FSI",
        "Group Sessions",
      ],
      filterDialog: false,
      snackbar: false,
      SuccessToast: false,
      ErrorToast: false,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      Permission: {},
      tableLoader: false, // data-table true or false
      dialog: false,
      isPlaying: false,
      search: "",
      headers: [
        { text: "#", value: "index" },
        { text: "Instructor", value: "instructor" },
        { text: "Course", value: "course" },
        { text: "Month", value: "month" },
        { text: " Royalty Rate", value: "royaltyrate" },
        { text: "# of Students", value: "noOfStudent" },
        { text: "Total Royalty Earned", value: "totalRoyaltyearned" },
        { text: "Statement", value: "statement" },
        { text: "", value: "actions", sortable: false },
      ],
      DataTableOne: [],
    };
  },
  computed: {
    ...mapGetters(["GetUserRolePermissions"]),
  },
  mounted() {
    this.Permission = this.GetUserRolePermissions.RolePermissions.find(
      (x) => x.Module === "Coordinator"
    );
    this.tableLoader = true;
    setTimeout(() => {
      (this.DataTableOne = [
        {
          index: 1,
          instructor: "Founders ",
          course: "BodyTalk",
          month: "feb",
          royaltyrate: "14",
          totalRoyaltyearned: "50",
          noOfStudent: "70",
          statement: "Session",
          isPlaying: false,
        },
        {
          index: 2,
          instructor: "Founders Session Intensive",
          course: "BodyTalk Courses",
          month: "feb",
          royaltyrate: "14",
          totalRoyaltyearned: "50",
          noOfStudent: "10",
          statement: "Session",
          isPlaying: false,
        },
      ]),
        (this.tableLoader = false);
    }, 1400);
  },
  methods: {
    DeleteData() {
      this.dialog = false;
      this.ErrorToast = true;
    },
    save() {
      this.btnloader = true;
      setTimeout(() => {
        this.btnloader = false;
        this.newcategorydialog = false;
        this.SuccessToast = true;
      }, 1400);
    },
    close() {
      this.organizeDialog = false;
    },
    cleanFilter() {
      this.filterCategoryArray = [];
      this.filterStatusArray = [];
      this.filterTypeArray = [];
      this.filterCourseArray = [];
    },
    toggleIsPlaying(obj) {
      this.DataTableOne = this.DataTableOne.map((e) => {
        if (e.index === obj) {
          e.isPlaying = !e.isPlaying;
          return e;
        }
        return e;
      });
      this.isPlaying = !this.isPlaying;
      
    },
  },
};
</script>

<style scoped>
#chip.v-chip.Course {
  background: #e8f3fa;
  padding: 0 16%;
  color: #0071bd;
}
#chip.v-chip.PaRama {
  background: #fdf7e7;
  padding: 0 16%;
  color: #d18911;
}

.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
</style>
